import {Component, Input, Output, EventEmitter} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TrackingService} from '@ox/data';
import {StepperReturnState, StepperValue} from '@ox/typings';

@Component({
  selector: 'webu-stepper-heading',
  templateUrl: './stepper-heading.component.html'
})
export class StepperHeadingComponent {
  @Input() steps: StepperValue[];
  @Input() currentStep: number;
  @Input() isUpdatePlanComponent = false;
  @Input() returnState: StepperReturnState;
  @Input() baseTrackingString: string;
  @Input() p15AnalyticsString?: string;
  @Input() upgradeDowngradeTrackingString?: string;
  @Input() trackingString?: string;
  @Output() ClickPreviousStep: EventEmitter<number> = new EventEmitter();
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public trackingService: TrackingService
  ) {}

  redirectTo(path: string) {
    this.router.navigate([`onstar/myplans${path?`/${path}`:''}`]);
  }

  goToStep(key: number) {
    if (this.shouldRedirectToPlansModify(key)) {
      this.redirectTo('plans-modify');
    }
  
    if (this.isPreviousStep(key)) {
      this.navigateToPreviousStep(key);
    }
  }
  
  shouldRedirectToPlansModify(key: number): boolean {
    return this.route.snapshot.url.toString() === 'yearly-billing' && key === 0;
  }
  
  isPreviousStep(key: number): boolean {
    return key < this.currentStep;
  }
  
  navigateToPreviousStep(key: number) {
    this.currentStep = key;
    this.fireTrackingEvent(key);
    this.emitPreviousStepEvent(key);
  }
  
  fireTrackingEvent(key: number) {
    const trackingLabel = `shop:review changes:link:shop:${this.steps[key]}`;
    this.trackingService.fireProp10Tracking(trackingLabel, '', '', this.returnState.name, '', true);
  }
  
  emitPreviousStepEvent(key: number) {
    this.ClickPreviousStep.emit(key);
  }
  
  goToReturnState() {
    this.fireReturnStateTrackingEvent();
    this.redirectTo('');
  }
  
  fireReturnStateTrackingEvent() {
    const trackingLabel = this.trackingString ?? 'shop:update plan:link:my plans';
    this.trackingService.fireProp10Tracking(trackingLabel, '', '', 'my plans', '', true);
  }
}